import { observer } from "mobx-react-lite";
import { useMemo } from "react";

import { useTran } from "@/hooks";
import { MultiSelect } from "@/components/common";
import { LOCATION_OPTIONS, KEY_IMPROVEMENT } from "@/lib/constants";
import { useCompanyStore } from "../hooks";

const CompanySetupStepFour = observer(({ errors }) => {
  const { t } = useTran();
  const { form, setField } = useCompanyStore();

  const locationOptions = useMemo(
    () =>
      LOCATION_OPTIONS.map((option) => ({
        value: option.key,
        label: option.value,
      })),
    [],
  );
  const objectiveOptions = useMemo(
    () =>
      KEY_IMPROVEMENT.map((option) => ({
        value: option.key,
        label: option.value,
      })),
    [],
  );

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <label className="text-sm font-medium text-foreground">
          {t("In which countries do you offer your products and services?")}
        </label>
        <MultiSelect
          options={locationOptions}
          value={form.serviceCountries}
          onChange={(values) => setField("serviceCountries", values)}
          placeholder={t("Select countries...")}
        />
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium text-foreground">
          {t("What are your key objectives for improvement?")}
        </label>
        <MultiSelect
          options={objectiveOptions}
          value={form.objectives}
          onChange={(values) => setField("objectives", values)}
          placeholder={t("Select objectives...")}
        />
        {errors?.step4 ? (
          <p className="text-sm text-amber-600">{errors.step4}</p>
        ) : null}
      </div>
    </div>
  );
});

export default CompanySetupStepFour;
